import { execute } from '@lib/graphql/execute'
import { graphql } from '@lib/graphql/gql'
import { QueryConfig } from '@lib/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

const countriesQueryDocument = graphql(`
  query Countries {
    countries {
      name
      code
      zones {
        name
        code
      }
    }
  }
`)

export const getCountries = () => {
  return execute(countriesQueryDocument)
}

export const getCountriesQueryOptions = () => {
  return queryOptions({
    queryKey: ['countries'],
    queryFn: () => getCountries(),
  })
}

type UseCountriesOptions = {
  queryConfig?: QueryConfig<typeof getCountries>
}

export const useCountries = ({ queryConfig }: UseCountriesOptions = {}) => {
  return useQuery({
    ...getCountriesQueryOptions(),
    ...queryConfig,
  })
}
